import React, { useEffect, useState } from 'react';
import { Mixpanel } from '@/utils/mixpanel';
import { getStrategySessionLink } from '@/utils/ts/userUtils';
import RightArrowIcon from '@mui/icons-material/EastRounded';
import { STRATEGY_SESSION_MAPPING } from '@Saral-Influencer-Marketing/saral-utils/src/constants/support';
import { useSelector } from 'react-redux';

import { updateStrategySessionStatus } from '../../../services/user.service';
import ButtonComponent from '../ButtonComponent/ButtonComponent';
import IconContainer from '../FtuxComponent/IconContainer';
import ModalComponent from './ModalComponent';

interface Day4StrategySessionModalProps {
  show: boolean;
  handleClose: () => void;
}

const Day4StrategySessionModal: React.FC<Day4StrategySessionModalProps> = ({ show, handleClose }) => {
  const { userDetails } = useSelector((state: any) => state.user);

  const [strategySessionLink, setStrategySessionLink] = useState(STRATEGY_SESSION_MAPPING['support@getsaral.com']);

  const updateUserInfo = async () => {
    await updateStrategySessionStatus();
  };

  useEffect(() => {
    const strategySession = getStrategySessionLink(userDetails?.trialGrantedBy || '');
    if (strategySession) {
      setStrategySessionLink(strategySession);
    }
  }, []);

  return (
    <ModalComponent show={show} onClose={handleClose} width={460} outsideClickClose={false}>
      <div className="warning-modal modal-main-content" style={{ padding: '16px 0' }}>
        <IconContainer icon="🤝" />
        <h2 style={{ marginBottom: 24, marginTop: 14 }}>It&apos;s been 4 days… need guidance?</h2>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', gap: '12px' }}>
          <p style={{ fontSize: 14, padding: '0 14px', textAlign: 'left' }}>
            You&apos;re halfway through your free trial now and we want to make sure you get value. Please watch the
            in-app videos for a step-by-step process you can replicate.
          </p>
          <p style={{ fontSize: 14, padding: '0 14px', textAlign: 'left' }}>
            If you’re serious about building an influencer program, book a consulting session where we&apos;ll set the
            right foundations and help you make the most out of SARAL.
          </p>
          <p style={{ fontSize: 14, padding: '0 14px 8px 14px', textAlign: 'left' }}>Got 30 minutes soon?</p>
        </div>
        <div className="modal-footer-button-container" style={{ padding: '0 10px' }}>
          <ButtonComponent
            onClick={() => {
              handleClose();
              updateUserInfo();
            }}
            variant="secondary"
            style={{ width: '50%' }}>
            I&apos;m fine, thanks!
          </ButtonComponent>
          <a href={strategySessionLink} target="_blank" rel="noreferrer" style={{ color: '#fff', width: '50%' }}>
            <ButtonComponent
              onClick={() => {
                handleClose();
                updateUserInfo();
                Mixpanel.track('booked_strategy_session', {
                  userId: userDetails?._id,
                });
              }}
              style={{ width: '100%' }}>
              Book a Session <RightArrowIcon />
            </ButtonComponent>
          </a>
        </div>
      </div>
    </ModalComponent>
  );
};

export default Day4StrategySessionModal;
